'use client';
import { ListCollection } from '@zag-js/collection';

const createListCollection = (options) => new ListCollection(options);

export { createListCollection };
